import { User } from "./types";

export function isDev() {
  return process.env.NODE_ENV === "development";
}

const currencyFormat = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

// Rounding values as they're calculated
export function CalculateStreamPoints(streams: number) {
  return pointsRounder(Math.pow(streams, 1 / 2.33) / 45);
}
export function CalculateSocialPoints(hits: number) {
  return pointsRounder(Math.pow(hits, 1 / 3) / 30);
}
export function CalculateShowPoints(capacity: number) {
  return pointsRounder(Math.pow(capacity, 1 / 2) / 18);
}

export function currencyRounder(n: number): number {
  return Math.max(Math.floor(n / 2), 1);
}

export function currencyFormatter(n: number): string {
  return currencyFormat.format(n);
}

export function pointsFormatter(n: number): string {
  return n.toFixed(2);
}

export function pointsRounder(n: number) {
  return Math.round((n + Number.EPSILON) * 100) / 100;
}

export function deepCloneUser(user: User): User {
  const playerData = structuredClone(user.playerData);
  const userData = structuredClone(user.userData);
  return {
    ...structuredClone(user),
    playerData,
    userData,
  };
}
